import React, { useCallback } from 'react';
import { Box } from '@mui/material';
import { Table } from '@devexpress/dx-react-grid-material-ui';
import { useDispatch } from "react-redux";
import { codeColorMap, codeColorMapHover } from 'lib/colors';
import { actions } from 'pages/Chart/Chart.redux';



const AllSymbolsDialogCell = (props) => {
	const id       = props.row.visit_id,
		  dispatch = useDispatch();

	const handleClose = () => dispatch(actions.setToolbar({ showAllSymbolsDialog: false }));

	const { row, column } = props;
	const { name } = column;
	const category = row.symbol_category;
	const color = codeColorMap[ category ] ?? codeColorMap.other;
	const hoverColor = codeColorMapHover[ category ] ?? codeColorMapHover.other;

	console.log({ props });

	const { children, ...restProps } = props;

	const style = name === 'symbol_abbreviation'
		? {
			width: '100%',
			cursor: 'pointer',
			borderLeft: `15px solid ${color}`,
			padding: 1.5,
			background: `linear-gradient(to left, #ffffff 50%, #ededed 50%)`,
			backgroundSize: '201% 100%',
			backgroundPosition: 'right bottom',
			transition: 'all 400ms ease',
			'&:hover': {
				borderLeft: `15px solid ${hoverColor}`,
				backgroundPosition: 'left bottom',
			},
		}
		: { cursor: 'pointer' };


	const handleSelection = () => {
		dispatch(actions.setToolbar({
			selectedButton: 'symbols',
			selectedTool: 'symbolSingle',
		}));

		dispatch(actions.resetSymbolOptions({
			symbol: props.row.symbol_id,
		}));

		handleClose();
	};


	return (

		<Table.Cell
			{...restProps}
			style={style}
			onClick={handleSelection}
		>
			{children}
		</Table.Cell>

	);
};


export default AllSymbolsDialogCell;
